<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-60">
      <div class="mt-30">
        <div>
          <h4>{{chapter.moduletitle}}</h4>
          <div class="menter fdc">
            <img :src="chapter.moduleimg" alt="" />
            <div class="menter_left" v-html="chapter.moduledesc"></div>
          </div>
          <div  style="border:1px dashed  #E1E1E1;"></div>
          <!-- <div class="letter">
            <img src="../../assets/images/letter_1.png" alt="" />
            <img src="../../assets/images/letter_2.png" alt="" />
          </div> -->
        </div>
        <div class="middel_center">
          <div class="center_list"  v-for="(item,index) in aboutUsInfo" :key="index">
            <div v-if="index %2 ==0" class="fdc">
                <div class="center_pricute">
                  <img  :src="item.moduleimg" alt="" />
                  <span  class="words">{{item.moduletitle}}</span>
                </div>
                <div class="center_text color_1" v-html="item.moduledesc">
                </div>
            </div>
            <div v-else class="fdc">          
               <div class="center_text color_3" v-html="item.moduledesc"></div>
               <div class="center_pricute">
                 <img :src="item.moduleimg" alt="" />
                 <span class="words">{{item.moduletitle}}</span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { aboutus } from "@/api/information";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
export default {
  components: { commBanner, titleHead },
  data() {
    return {
      headTitle: "关于我们",      
      aboutUsInfo:[],
	  chapter:{},
      obj: {
        title: "关于我们",
        isShow: false,
        isColor: false,
        roleType:'',
        personalType:''  
      }
    }
  },
  created() {
    this.getMate();
    if(this.$store.state.user.userInfo != null){
       this.obj.roleType = this.$store.state.user.userInfo.type;
       this.obj.personalType = 9;
    }
  },
  mounted(){
    this.getAboutUsInfo();
  },
  methods: {
    getAboutUsInfo() {
      aboutus({ type: 0 }).then((res) => {
		if(res.code == 0){ 
        res.data.forEach((item,index)=>{
		  index == 0 ? this.chapter = item : this.aboutUsInfo.push(item);
        });
	   }
      });
    },
    getMate(){
        var metas = document.getElementsByTagName("meta"); 
        document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
    },
  },
};
</script>
<style scoped>
.mb-60 {
  margin-bottom: 60px;
}
.title_img {
  height: 25px;
}
h4 {
  color: #a6da5c;
  font-size: 22px;
}
.menter {
  margin-top: 20px;
  /* font-size: 12px; */
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #494b4d;
  line-height: 30px;
}
.menter img {
  width: 30%;
  height: 256px;
  /* transition: all 0.6s; */
}
/* .menter img:hover{
  transform: scale(1.2);
} */




.menter_left {
  margin: 0px 30px;
  /* font-size: 14px; */
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
}
.menter_left>>>p{
  width: 50%;
  margin-right: 25px;
  /* font-size: 14px; */
}

.menter_left>>>.ql-size-large{
  font-size: 1.5em !important;
}
.menter_left>>>.ql-size-huge{
   font-size: 2.5em !important;
}
.menter_left>>>.ql-size-small{
  font-size: 0.75em !important;
}



.menter_right {
  margin-right: 20px;
}
.letter {
  margin-top: 20px;
  margin-right: 20px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.letter img:nth-child(1) {
  width: 273px;
  height: 22px;
}
.letter img:nth-child(2) {
  width: 412px;
  height: 32px;
  margin-top: 10px;
}
.middel_center {
  margin-top: 20px;
  width: 100%;
}

.center_pricute {
  width: 50%;
  height: 361px;
  overflow: hidden;
  position: relative;
}

.center_pricute img {
  width: 100%;
  height: 361px;
  cursor: pointer;
  transition: all 0.6s;
}
.center_pricute img:hover {
  transform: scale(1.4);
}
.words {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  position: absolute;
  left: 40%;
  top: 44%;
}
.center_text {
  width: 50%;
  padding: 0px 40px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 34px;
}
.color_1 {
  color: #169fac;
}
.color_2 {
  color: #1d5ac5;
}
.color_3 {
  color: #faa13b;
}
.color_4 {
  color: #70a01a;
}
</style>


// WEBPACK FOOTER //
// src/view/other/chapter_users.vue